/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ quota: NonNullable<unknown>, budget: NonNullable<unknown> }} Sub_Quotas_Over_Budget_Warn_OneInputs */



/**
* | output |
* | --- |
* | "A limit of {quota} is above your organisation's total budget of {budget} — that user still stops at {budget}." |
*
* @param {Sub_Quotas_Over_Budget_Warn_OneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_quotas_over_budget_warn_one = /** @type {((inputs: Sub_Quotas_Over_Budget_Warn_OneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Quotas_Over_Budget_Warn_OneInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Ein Limit von ${i?.quota} liegt über dem Gesamtbudget Ihrer Organisation von ${i?.budget} – dieser Nutzer wird weiterhin bei ${i?.budget} gestoppt.`)
	return /** @type {LocalizedString} */ (`A limit of ${i?.quota} is above your organisation's total budget of ${i?.budget} — that user still stops at ${i?.budget}.`)
});